import axiosClient from '@clients/axiosClient';

type IGetCustomerDetails = { customerId: number };
type IGetCustomers = { accountId: number };

type GetCustomerCards = { accountId: number; customerId: number };

export type CustomerDetails = {
    program_id: number;
    account_id: number;
    entity: Entity;
    customer: Customer;
};

export type Entity = {
    id: number;
    name: string;
    document_number: string;
    registration: string;
    birth_date: Date;
    gender: string;
    mothers_name: string;
    marital_status: string;
};

export type Customer = {
    id: number;
    email: string;
    printed_name: string;

    name?: string;
    social_name: string | null;
    nickname: string | null;
    is_owner: boolean;
    is_active: boolean;
};

export type Customers = {
    current_page: number;
    per_page: number;
    items: CustomersItem[];
};

export type CustomersItem = {
    account_id: number;
    customer: Customer;
};

export type CustomerCard = {
    id: number;
    hash: string;
    status: string;
    stage: string;
    printed_name: string;
    name: string;
    type: string;
    issuing_date: string;
    transaction_limit: number;
    expiration_date: string;
    last_4_digits: string;
    track_number: number;
    reissued_card_id: number;
    contactless_enabled: boolean;
    abu_enabled: boolean;
    dual_message_debit: boolean;
    embossing_custom_field: string;
    mode: string;
    metadata: {
        'my-custom-key': string;
    };
};

export type CustomerCardResponse = CustomerCard[];

const customers = () => {
    const client = axiosClient();

    return {
        async getCustomerDetails({ customerId }: IGetCustomerDetails) {
            const { data } = await client.get<CustomerDetails>(
                `accounts/v2/customers/${customerId}`,
            );
            return data;
        },
        async getCustomers({ accountId }: IGetCustomers) {
            const { data } = await client.get<Customers>(
                `accounts/v2/accounts/${accountId}/customers`,
            );
            return data;
        },
        async getCustomerCards({ accountId, customerId }: GetCustomerCards) {
            const { data } = await client.get<CustomerCardResponse>(
                `wallet/v1/customers/${customerId}/accounts/${accountId}/cards`,
            );
            return data;
        },
    };
};

export default customers;
